import PropTypes from 'prop-types';
import React from 'react';

import {
    Footer,
    Main,
    Meta,
    SideBar
} from '$partials/global';

import { GridMixedAjax } from '$partials/modules/blocks';
import { Stream as ModuleStream } from '$partials/modules';
import { useLanguage } from '$contexts/language.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const SearchPage = (props) => {
    // hooks
    const { translate: t } = useLanguage();

    // misc
    props.data?.items?.edges?.forEach((edge, idx) => {
        edge.node.originalIndex = idx;
    });

    // render
    return (
        <>
            <Meta
                domain={props.domain}
                title={`Search${props.searchTerm ? ': ' + props.searchTerm : ''}`}
                url={props.data?.uri} />

            <SideBar
                localePages={props.data?.translations?.edges}
                navigation={props.data?.navigation}
                search={props.data?.search}>
                {/* header */}
                <div className='mt9 sm-mt9 md-mt0 mbn7 sm-mbn7 md-mbn7'>
                    {/* content */}
                    <div className='container'>
                        <div className='module'>
                            <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                                <div className='flex flex-wrap'>
                                    {/* side title */}
                                    <div className='absolute top-0 md-relative md-col-2'>
                                        <div className='px-gutter md-show'>
                                            <h1 className='type-style-5 side-title'>
                                                {t('Search')}
                                            </h1>
                                        </div>
                                    </div>

                                    {/* content */}
                                    <div className='col-11 sm-col-8 md-col-7'>
                                        <div className='ml9 sm-ml9 md-ml0'>
                                            <div className='px-gutter'>
                                                {/* title */}
                                                <h2 className='rich-text type-style-1'>
                                                    <span>
                                                        {props.data?.items?.total || '0'}
                                                    </span>

                                                    <span>
                                                        {`${t(' results for')}: `}
                                                    </span>

                                                    <span>
                                                        &ldquo;{props.searchTerm}&rdquo;
                                                    </span>
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SideBar>

            <SideBar
                className='mtn7 sm-mtn7 md-mtn12'
                isHeader={false}>
                <Main className='container'>
                    {/* search listing */}
                    <div className='module'>
                        {props.data?.items?.edges?.length > 0 && (
                            <GridMixedAjax
                                ajaxPath='/api/v1/search'
                                items={props.data?.items}
                                urlPath={'search'} />
                        )}
                    </div>

                    {/* modules */}
                    <ModuleStream
                        modules={props.data?.search?.modules}
                        namespace='search-listing' />
                </Main>

                <Footer { ...props.data?.footer }/>
            </SideBar>
        </>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    data: PropTypes.shape({
        codeSnippet: PropTypes.object,
        footer: PropTypes.object,
        items: PropTypes.object,
        navigation: PropTypes.object,
        search: PropTypes.shape({
            id: PropTypes.string,
            modules: PropTypes.array
        }),
        translations: PropTypes.object,
        uri: PropTypes.string,
    }),
    domain: PropTypes.string,
    searchTerm: PropTypes.string
};

SearchPage.propTypes = propTypes;

export { SearchPage };

export default SearchPage;
